module.exports = __webpack_public_path__ + "static/img/couponbgc.e2ab4345.png";